import React, { useState } from "react";
import {
  Paper,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SalesAverageTime = ({ data }) => {
  const averageData = data?.averageOrderTime;
  if (!averageData) return null;
  const [viewMode, setViewMode] = useState("perHour");

  const chartConfig = (() => {
    if (viewMode === "perDay") {
      const labels = averageData.current.perDay.map((d) => d.date);
      const data = averageData.current.perDay.map((d) => d.avgMinutes);
      return {
        labels,
        datasets: [
          {
            label: "Avg Serving Time (minutes)",
            data,
            backgroundColor: "#4CAF50",
          },
        ],
      };
    }

    if (viewMode === "perHour") {
      const labels = averageData.current.perHour.map((d) => {
        const hour = d.hour % 12 === 0 ? 12 : d.hour % 12;
        const suffix = d.hour < 12 ? "AM" : "PM";
        return `${hour} ${suffix}`;
      });
      const data = averageData.current.perHour.map((d) => d.avgMinutes);
      return {
        labels,
        datasets: [
          {
            label: "Avg Serving Time (minutes)",
            data,
            backgroundColor: "#2196F3",
          },
        ],
      };
    }

    if (viewMode === "perRange") {
      return {
        labels: ["Previous Range", "Current Range"],
        datasets: [
          {
            label: "Avg Serving Time (minutes)",
            data: [
              averageData.previous.rangeAverage,
              averageData.current.rangeAverage,
            ],
            backgroundColor: ["#9E9E9E", "#FF9800"],
          },
        ],
      };
    }

    return { labels: [], datasets: [] };
  })();

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text:
          viewMode === "perDay"
            ? "Average Serving Time per Day"
            : viewMode === "perHour"
            ? "Average Serving Time per Hour"
            : "Average Serving Time (Date Range)",
      },
    },
  };

  return (
    <Paper sx={{ mt: 3, p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Average Serving Time</Typography>
        <FormControl size="small">
          <InputLabel>View</InputLabel>
          <Select
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value)}
            label="View"
          >
            <MenuItem value="perHour">Per Hour</MenuItem>
            <MenuItem value="perDay">Per Day</MenuItem>
            <MenuItem value="perRange">Per Date Range</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Bar data={chartConfig} options={chartOptions} />
      </Box>
    </Paper>
  );
};

export default SalesAverageTime;
